import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Toast surface. Deliberately dumb: a stack of transient messages, no queueing
 * policy, no animation library. Errors stay twice as long as confirmations.
 */
import { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
const Ctx = createContext(null);
export function ToastProvider({ children }) {
    const [items, setItems] = useState([]);
    const seq = useRef(0);
    const remove = useCallback((id) => {
        setItems((prev) => prev.filter((t) => t.id !== id));
    }, []);
    const push = useCallback(({ tone = "info", title, detail }) => {
        const id = ++seq.current;
        setItems((prev) => [...prev.slice(-3), { id, tone, title, detail }]);
        window.setTimeout(() => remove(id), tone === "error" ? 9000 : 4500);
    }, [remove]);
    const api = useMemo(() => ({
        push,
        ok: (title, detail) => push({ tone: "ok", title, detail }),
        error: (title, detail) => push({ tone: "error", title, detail }),
    }), [push]);
    return (_jsxs(Ctx.Provider, { value: api, children: [children, _jsx("div", { className: "toasts", role: "status", "aria-live": "polite", children: items.map((t) => (_jsxs("div", { className: `toast${t.tone === "error" ? " toast--error" : t.tone === "ok" ? " toast--ok" : ""}`, children: [_jsxs("div", { children: [_jsx("div", { style: { fontWeight: 600 }, children: t.title }), t.detail ? _jsx("div", { style: { opacity: 0.8, marginTop: 2 }, children: t.detail }) : null] }), _jsx("button", { type: "button", className: "btn btn--ghost btn--sm", style: { color: "inherit", marginLeft: "auto" }, onClick: () => remove(t.id), "aria-label": "dismiss", children: "\u2715" })] }, t.id))) })] }));
}
export function useToast() {
    const v = useContext(Ctx);
    if (!v)
        throw new Error("useToast must be used inside <ToastProvider>");
    return v;
}
